import { Route, Routes } from 'react-router-dom';
import { getUserFromSessionStorage } from '../../core/services/auth';
import Candidates from './Candidates';
import ClientVoteLogs from './ClientVoteLogs';
import ElectionResults from './ElectionResults';
import Elections from './Elections';
import Polls from './Polls';
import Positions from './Positions';

const ElectionManagement = () => {
  const user = getUserFromSessionStorage();

  return (
    <Routes>
      <Route path="/elections" element={<Elections />} />
      <Route path="/positions" element={<Positions />} />
      <Route path="/candidates" element={<Candidates />} />
      <Route path="/polls" element={<Polls />} />
      <Route path="/election-results" element={<ElectionResults />} />
      {user?.staff_id === '1000002' && (
        <Route path="/client-vote-logs" element={<ClientVoteLogs />} />
      )}
    </Routes>
  );
};

export default ElectionManagement;
